import { useQuery } from '@apollo/client'
import { ExpensablesStatusCountsDocument } from 'generated/resources/graphql'

import type { StatusCounts } from './useDataCollectionConfig'

interface UseExpensablesStatusCountsParams {
  companyId: number
  employeeIds?: number[]
  groupId?: number
  includeManualDrafts?: boolean
  from?: Date
  to?: Date
}

export const useExpensablesStatusCounts = ({
  companyId,
  employeeIds,
  groupId,
  includeManualDrafts,
  from,
  to,
}: UseExpensablesStatusCountsParams): StatusCounts | undefined => {
  const { data } = useQuery(ExpensablesStatusCountsDocument, {
    variables: {
      companyId,
      employeeIds,
      groupIds: groupId ? [groupId] : undefined,
      includeManualDrafts,
      from,
      to,
    },
    fetchPolicy: 'cache-and-network',
  })

  if (!data) {
    return undefined
  }

  return {
    draft: data.expenses.draftCount.totalCount ?? 0,
    pending: data.expenses.pendingCount.totalCount ?? 0,
    approved: data.expenses.approvedCount.totalCount ?? 0,
    paid: data.expenses.paidCount.totalCount ?? 0,
  }
}
